import { render, staticRenderFns } from "./riskQues.vue?vue&type=template&id=b801e736&"
import script from "./riskQues.vue?vue&type=script&lang=js&"
export * from "./riskQues.vue?vue&type=script&lang=js&"
import style0 from "./riskQues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports